import React from 'react';

export const SearchEmptyIcon = () => (
  <svg
    width="220"
    height="140"
    viewBox="0 0 223 172"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden>
    <g clipPath="url(#searchEmptyIconClip0)">
      <path d="M38.2969 120.238L44.6608 113.874L61.6314 130.845L38.2969 120.238Z" fill="#FDC300" />
      <rect
        width="24"
        height="155.377"
        transform="matrix(0.707107 0.707107 0.707107 -0.707107 44.6602 113.874)"
        fill="#FDC300"
      />
    </g>
    <rect
      x="2.04904"
      y="-0.549038"
      width="46"
      height="17"
      rx="8.5"
      transform="matrix(0.866025 0.5 0.5 -0.866025 150.67 102.363)"
      fill="#B8CAC4"
      stroke="#21282B"
      strokeWidth="3"
    />
    <path
      d="M156.336 101.649C158.489 102.892 161.241 102.154 162.484 100.002C163.726 97.8498 162.989 95.0976 160.836 93.855L150.877 88.105L146.377 95.8992L156.336 101.649Z"
      fill="white"
      stroke="#21282B"
      strokeWidth="3"
    />
    <rect
      width="102"
      height="112"
      rx="51"
      transform="matrix(-2.58096e-08 -1 -1 2.58096e-08 159.148 120.308)"
      fill="white"
      stroke="#21282B"
      strokeWidth="3"
    />
    <path
      d="M73.9727 105.906C54.0559 85.9894 54.0559 53.698 73.9727 33.7812"
      stroke="#21282B"
      strokeWidth="3"
      strokeLinecap="round"
    />
    <path
      d="M140.117 54.9968C144.482 64.2706 144.699 75.0125 140.768 84.4324"
      stroke="#21282B"
      strokeWidth="3"
      strokeLinecap="round"
    />
    <g clipPath="url(#searchEmptyIconClip1)">
      <g clipPath="url(#searchEmptyIconClip2)">
        <path d="M54.8438 96.8701L66.1575 85.5564L94.4417 113.841L54.8438 96.8701Z" fill="#FDC300" />
        <rect
          width="40"
          height="100"
          transform="matrix(0.707107 0.707107 0.707107 -0.707107 66.1562 85.5566)"
          fill="#FDC300"
        />
      </g>
    </g>
    <rect x="67.5" y="27.5" width="85" height="85" rx="42.5" stroke="#21282B" strokeWidth="3" />
    <defs>
      <clipPath id="searchEmptyIconClip0">
        <rect
          width="24"
          height="164.377"
          fill="white"
          transform="matrix(0.707107 0.707107 0.707107 -0.707107 38.2969 120.238)"
        />
      </clipPath>
      <clipPath id="searchEmptyIconClip1">
        <rect x="66" y="26" width="88" height="88" rx="44" fill="white" />
      </clipPath>
      <clipPath id="searchEmptyIconClip2">
        <rect
          width="40"
          height="116"
          fill="white"
          transform="matrix(0.707107 0.707107 0.707107 -0.707107 54.8438 96.8701)"
        />
      </clipPath>
    </defs>
  </svg>
);
